export default async function useApi(
  url: string,
  method: 'GET' | 'POST' | 'PUT' | 'DELETE',
  body?: any,
  isForm?: boolean,
  tenantId?: string,
  hasNoAuth?: boolean,
  customToken?: string
) {
  const { apiBaseUrl } = useRuntimeConfig().public
  const { user, contact, logout } = useUserStore()
  const isContactUrl = url.startsWith('css/') || url.startsWith('public/')

  try {
    const response = await $fetch<any>(`${apiBaseUrl}${url}`, {
      method,
      headers: {
        accept: 'application/json',
        'X-Tenant': `${tenantId || (isContactUrl ? contact.tenantId : user.tenant_identifier)}`,
        ...(hasNoAuth
          ? {}
          : {
              Authorization: `Bearer ${
                customToken || (isContactUrl ? contact.token : user.api_token)
              }`
            }),
        ...(body && !isForm ? { 'Content-Type': 'application/json' } : {})
      },
      body: isForm ? body : JSON.stringify(body)
    })

    // A page showing what the review changed follows every written answer
    if (isSurveyAnswerWrite(url, method)) {
      useEventBus<SurveyAnswerWrite>(SURVEY_ANSWER_SAVED_EVENT).emit({
        url,
        method,
        body,
        response
      })
    }

    return response
  } catch (error: any) {
    // Extract error details
    const errorData = error
    const errorFields = errorData?.data?.errors || { message: [errorData?.data?.message ?? ''] }

    // Display error details to the user
    Object.keys(errorFields).forEach((field) => {
      toast.value?.add({
        severity: 'error',
        summary: 'Fehler',
        detail: errorFields?.[field]?.[0] || 'Unknown error',
        life: TOAST_LIFE_TIME_MS
      })
    })
    if (error.statusCode === 401) {
      logout()
      return {}
    }
  }
}
